/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Codice di un motivo della tariffa mensa del cittadino
 */
export enum MotivoTariffaCittadino {

    ESENTE = 'ESENTE',

    FASCIA_ISEE = 'FASCIA_ISEE',

    NESSUN_ISEE = 'NESSUN_ISEE',

    RESIDENZA = 'RESIDENZA',

    ORDINE_SCUOLA = 'ORDINE_SCUOLA',

    POSIZIONE_FRATELLI = 'POSIZIONE_FRATELLI',

    SCONTO_FRATELLI = 'SCONTO_FRATELLI',

    CALCOLO = 'CALCOLO'
}

